import { useFormik } from "formik";
import React, { useState } from "react";
import * as yup from "yup";
import { CancelButton, SubmitButton } from "../../../utils/Button";
import { handleKeyDown } from "../../../utils/OtherFunctions";
import { CloseIcon } from "../../../assets/icons";
import { NuInput } from "../../../utils/Inputs";
import useAddData from "../../../hooks/useAddData";

function CreateForm({ visible, onClose, id, refreshData }) {
  const { isCreateLoading, addData } = useAddData();
  const [createNew, setCreateNew] = useState({
    header_no: "",
    header_title: "",
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      header_no: yup.string().required("Header No Required"),
      header_title: yup.string().required("Header Required"),
    }),
    onSubmit: (value, { resetForm }) => {
      addData({
        url: `/Headers/standard/${id}/activity-type/0/`,
        value: value,
        resetForm: resetForm,
        onClose: onClose,
        getData: refreshData,
      });
    },
  });

  const closeFunction = () => {
    formik.resetForm();
    onClose();
  };

  if (!visible) return null;
  return (
    <>
      <div
        id="modal"
        className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
      flex justify-center items-center "
      >
        <div className="bg-white mt-12 p-2 rounded-xl w-6/12">
          <div className="flex items-start justify-between px-5 py-2  rounded-t">
            <h3 className="text-base 2xl:text-lg font-semibold">
              Create Header
            </h3>
            <span
              className="h-6 w-6 text-2xl block cursor-pointer"
              onClick={closeFunction}
            >
              <CloseIcon />
            </span>
          </div>
          <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
            <div className="relative   max-h-[calc(100vh-180px)] overflow-y-auto  flex flex-wrap justify-between text-left">
              <NuInput
                formik={formik}
                name="header_no"
                label="Header No."
                width="w-1/2"
                placeholder= "Ex: 1"
              />
              <NuInput
                formik={formik}
                name="header_title"
                label="Header"
                width="w-1/2"
                placeholder="Ex: Header"
              />

              <div className=" w-full flex items-center px-3 justify-end pb-6 rounded-b">
                <CancelButton
                  onClose={closeFunction}
                  isLoading={isCreateLoading}
                />
                <SubmitButton isLoading={isCreateLoading} />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default CreateForm;
